import { useState, useEffect } from 'react';

export const useCollapsible = ({
  contentRef,
  expanded,
}) => {
  const [heightContent, setHeightContent] = useState(0);

  useEffect(() => {
    if (expanded && contentRef.current) {
      setHeightContent(contentRef.current.getBoundingClientRect().height);
    } else {
      setHeightContent(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  return { heightContent };
};
